import { LINK_SPI_RELEASE_NOTES } from '../../constants/links';

function ReleaseNotes() {
  return (
    <div className="nhsuk-grid-column-two-thirds">
      <h2 className="landing-page__heading">Release notes</h2>
      <p
        className="nhsuk-u-body-s nhsuk-u-margin-bottom-1"
        data-testid="app-version"
      >
        Latest version :
        {' '}
        {import.meta.env.VITE_APP_VERSION || 'unknown'}
      </p>
      <p className="nhsuk-u-body-s" data-testid="release-date">
        Release date :
        {' '}
        {import.meta.env.VITE_APP_LAST_RELEASED || 'unknown'}
      </p>
      <a
        href={LINK_SPI_RELEASE_NOTES}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="release-notes-link"
        aria-label="Read SPI release notes (opens in a new tab)"
      >
        Read release notes
      </a>
    </div>
  );
}

export default ReleaseNotes;
